import React, { PropsWithChildren } from "react";
import { Drawer } from "antd";
import CloseIcon from "@assets/svg/close.svg";
import PortalRender from "./PortalRender/PortalRender";

type BottomSheetProps = {
  open: boolean;
  title?: string;
  onClose: () => void;
};

export const BottomSheet = ({
  open,
  title,
  onClose,
  children,
}: PropsWithChildren<BottomSheetProps>) => {
  return (
    <>
      <div
        id="custom-drawer-container"
        style={{ position: "relative", zIndex: 10000 }}
      />

      <Drawer
        placement="bottom"
        closable={false}
        onClose={onClose}
        open={open}
        getContainer={() => document.getElementById("custom-drawer-container")!}
        rootStyle={{
          zIndex: 10000,
        }}
        height="auto"
        className="tailwind-bottom-drawer"
        bodyStyle={{
          padding: "1rem",
        }}
      >
        <div className="flex items-center justify-between">
          <div className="font-semibold">{title}</div>
          <div onClick={onClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>
        {children}
      </Drawer>
    </>
  );
};
